angular
    .module('MyApp')
    .service('DeclaracaoImpostoRendaService', ['$resource', '$q', 'SessionData', 'Configs', 
    	function($resource, $q, SessionData, Configs) {
        var _aluno = SessionData.aluno;
           
        this.listarAnos = function () {
          let defer = $q.defer();
          var _objAluno = {
            codAluno: SessionData.aluno.list[_aluno.selecionado].codAluno
          };

          $resource(Configs.getApiServer() + '/financeiro/codAluno/:codAluno/listarAnosDividaAluno', {}, {
            cache: false,
            query: {
              method: 'GET'
            }
          })
          .query(_objAluno, function (result) {
            defer.resolve(result);
          }, function (err) {
            defer.reject(err);
          });
          return defer.promise;
        };
}]);